import React from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { capitalizeFirstLetter } from './common';
import { ROLES } from './constant';

const getCourseName = (row) => {
  return row?.postGraduationCourseName || row?.graduationCourseName || row?.diplomaCourseName || "";
};

const getBranchName = (row) => {
  return row?.postGraduationBranchName || row?.graduationBranchName || row?.diplomaBranchName|| "";
};

export const downloadPDF = (tableHeader, data, filename) => {
  const tableHeaderKey = Object.keys(tableHeader[0]); // API field names
  const tableHeaderValue = Object.values(tableHeader[0]); // Display names

  const rows = data.map(row =>
    tableHeaderKey.map(col => {
      if (filename === "payment") {
        if (col === 'userType') {
          if (row?.userDetails?.userType === ROLES.OFF_STUDENT) return 'Off Student';
          if (row?.userDetails?.userType === ROLES.ON_STUDENT) return 'On Student';
        } else if (col === 'name' && (row?.userDetails?.userType === ROLES.OFF_STUDENT || row?.userDetails?.userType === ROLES.ON_STUDENT)) {
          return capitalizeFirstLetter(row?.userDetails?.firstName || "");
        }
        return capitalizeFirstLetter(row[col] || row?.userDetails?.[col] || "");
      } else if (filename === "student") {
        if (col === 'name') {
          return `${capitalizeFirstLetter(row?.firstName || "")} ${capitalizeFirstLetter(row?.lastName || "")}`;
        } else if (col === 'course') {
          return capitalizeFirstLetter(getCourseName(row)); // ✅ Fixed missing return
        } else if (col === 'branch') {
          return capitalizeFirstLetter(getBranchName(row)); // ✅ Fixed missing return
        }
        return capitalizeFirstLetter(row[col] || row?.userDetails?.[col] || "");
      }
      return capitalizeFirstLetter(row[col] || row?.userDetails?.[col] || "");
    })
  );

  const doc = new jsPDF({ orientation: 'landscape' });

  const headerStyles = {
    fillColor: '#1e336a',
    textColor: '#ffffff',
    fontSize: 12,
    fontStyle: 'bold',
  };

  const bodyStyles = {
    fontSize: 10,
    textColor: "#1e336a",
  };

  autoTable(doc, {
    head: [tableHeaderValue],
    body: rows,
    headStyles: headerStyles,
    bodyStyles: bodyStyles,
  });

  doc.save(`${filename}.pdf`);
};

export const downloadPDF1 = (data, filename) => {
  const rows = data.map((row) => Object.values(row));
  const doc = new jsPDF();

  doc.autoTable({
    body: data,
  });

  doc.save(`${filename}.pdf`);
};


export const generateAndDownloadPDF = () => {

  const pageSize = { width: 210, height: 297 }; // A4 size in millimeters
  const doc = new jsPDF({ format: [pageSize.width, pageSize.height] });

  const html = `
  <h1 className="mt-0 mb-0">Welcome To The easycampus</h1>

  `;

  doc.setFontSize(12);
  doc.setFont('helvetica');
  // doc.fromHTML(html, 15, 15);
  

  // const marginLeft = (pageSize.width - doc.getStringUnitWidth(html) * doc.internal.getFontSize()) / 2;
  doc.html(html, {
    x: 15,
    y: 15, // You can adjust the y-coordinate as needed
    callback: function (doc) {
      doc.save('custom_form.pdf');
    },
  });

};
